import { render, staticRenderFns } from "./singlePerformance.vue?vue&type=template&id=1aec4baa&scoped=true"
import script from "./singlePerformance.vue?vue&type=script&lang=js"
export * from "./singlePerformance.vue?vue&type=script&lang=js"
import style0 from "./singlePerformance.vue?vue&type=style&index=0&id=1aec4baa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aec4baa",
  null
  
)

export default component.exports